import React, { useState } from 'react';
import callPng from '../images/call1.png';
import logo from '../images/Logo.png';
import { NavLink, useLocation } from "react-router-dom";
import '../Style/Header.css'
import contact from '../images/contac.png'
const Header = () => {
    const location = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    return (
        <div className='headerMain'>
            <div className='nav-bar'>
                <div className='nav-bar-main'>
                    <div className='nav-bar-logo'>
                        <img src={logo} width={70} alt="logo" />
                        <div className = 'header-name'>
                            <h5>IDEA TECH HUB</h5>
                            <p>ENGINEERING LLP</p>
                        </div>
                    </div>
                    <button className='hamburger-menu  LLPenu' onClick={() => setMenuOpen(!menuOpen)}>
                        ☰
                    </button>
                    <div className={`nav-bar-menu ${menuOpen ? 'open' : ''}`}>
                        <div className='nav-bar-menu-1'>
                            <NavLink
                                to="/"
                                className={({ isActive }) => (isActive ? 'active-home' : 'inactive')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Home
                            </NavLink>

                            <a
                                href="#aboutus"
                                className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                onClick={() => setMenuOpen(false)}
                            >
                                About
                            </a>
                            <a
                                href='#process'
                                className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                onClick={() => setMenuOpen(false)}
                            >
                                Expertise
                            </a>

                            <a
                                href="#from-bg"
                                className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                onClick={() => setMenuOpen(false)}
                            >
                                <img src={contact} width={25} className='contact' />
                                {/* Contact */}
                            </a>
                        </div>
                        {/* <div className='contact-info'>
                            <img src={callPng} width={35} alt="logo" />

                            <div>
                                <p>+91 99943 33049<br></br>Call Us Anytime</p>
                            </div>
                        </div> */}
                    </div>

                </div>
            </div>

        </div>
    );
};

export default Header;
